"use client"

import React, { createContext, useContext, useState } from "react"

const TransitionImageContext = createContext(null)

export const TransitionImageProvider = ({ children }) => {
  const [sharedImage, setSharedImage] = useState(null)

  return <TransitionImageContext.Provider value={{ sharedImage, setSharedImage }}>{children}</TransitionImageContext.Provider>
}

export const useTransitionImage = () => {
  const context = useContext(TransitionImageContext)
  if (!context) {
    throw new Error("useTransitionImage must be used within a TransitionImageProvider")
  }
  return context
}
